'use strict'

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./formik.cjs.production.js');
} else {
  module.exports = require('./formik.cjs.development.js');
}


//////////////////
// WEBPACK FOOTER
// ./~/formik/dist/index.js
// module id = 66
// module chunks = 166022755830701 210386719708000